import Layout from './layout';
import Title from './title';

export default Layout;

export {
  Title
};
